export const citationStyles = {
  'unconfirmed': 'Choose for each assignment',
  'cite-them-right-harvard': 'Cite Them Right Harvard',
  apa: 'APA 7', mla: 'MLA 9',
  'chicago-author-date': 'Chicago 18 · author–date', 'chicago-notes': 'Chicago 18 · notes and bibliography',
  vancouver: 'Vancouver · NLM', ieee: 'IEEE', ama: 'AMA 11',
  'mhra-author-date': 'MHRA 4 · author–date', 'mhra-notes': 'MHRA 4 · notes', oscola: 'OSCOLA 4',
  acs: 'ACS 2026', 'cse-author-date': 'CSE 9 · name–year', 'cse-numeric': 'CSE 9 · citation sequence',
  nature: 'Nature', custom: 'Another style (manual)',
} as const;
